import { useState } from 'react';
import { faqList } from '@/mocks/anime';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-14">
          <div className="lg:col-span-1">
            <span className="text-xs font-medium tracking-wide text-primary-600">常见问题</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
              关于观看，你可能想问的几件事
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
              把浏览、播放、高清、免费、全集与无广告相关的高频疑问整理在这里，点开即可查看说明，内容均在本页直接可读。
            </p>
            <div className="mt-6 rounded-lg bg-primary-50 border border-primary-200 p-4">
              <p className="text-sm leading-relaxed text-primary-900">
                <i className="ri-information-line mr-1"></i>
                本页只做作品信息整理，不涉及账号与真实提交，所有筛选与展开操作都在本地完成。
              </p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="divide-y divide-background-200 border border-background-200 rounded-lg overflow-hidden bg-background-50">
              {faqList.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.q}>
                    <button
                      type="button"
                      onClick={() => toggle(index)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left transition-colors hover:bg-background-100"
                    >
                      <span className="text-sm md:text-base font-medium text-foreground-950">
                        {item.q}
                      </span>
                      <span className="w-7 h-7 shrink-0 flex items-center justify-center rounded-full bg-background-100 text-foreground-600">
                        <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                      </span>
                    </button>
                    <div className={`px-4 md:px-5 pb-4 -mt-1 ${isOpen ? '' : 'hidden'}`}>
                      <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}